export const RECRUITMENT_STAGES = [
  { id: 'new', title: 'New', color: '#3b82f6' },
  { id: 'screening', title: 'Screening', color: '#6366f1' },
  { id: 'interview', title: 'Interview', color: '#8b5cf6' },
  { id: 'offer', title: 'Offer', color: '#eab308' },
  { id: 'background', title: 'Background Check', color: '#f97316' },
  { id: 'onboarding', title: 'Onboarding', color: '#14b8a6' },
  { id: 'hired', title: 'Hired', color: '#22c55e' },
];

export const APPLICANTS_QUERY = `
  query RecruitmentApplicants {
    recruitmentApplicants {
      id
      appId
      name
      email
      phone
      role
      experience
      priority
      stage
      branch
      recruiter
      appliedDate
      avatarColor
      notes
      resumeFileKey
      resumeFileName
      resumeFileUrl
      createdAt
    }
  }
`;

export const CREATE_APPLICANT = `
  mutation CreateRecruitmentApplicant($input: CreateRecruitmentApplicantInput!) {
    createRecruitmentApplicant(input: $input) {
      id
      appId
      name
      email
      phone
      role
      experience
      priority
      stage
      branch
      recruiter
      appliedDate
      avatarColor
      notes
      resumeFileKey
      resumeFileName
      resumeFileUrl
      createdAt
    }
  }
`;

export const UPDATE_APPLICANT_STAGE = `
  mutation UpdateRecruitmentApplicantStage($id: String!, $stage: ApplicantStage!) {
    updateRecruitmentApplicantStage(id: $id, stage: $stage) {
      id
      stage
    }
  }
`;

export const REMOVE_APPLICANT = `
  mutation RemoveRecruitmentApplicant($id: String!) {
    removeRecruitmentApplicant(id: $id)
  }
`;

export const APPLY_FORM_QUERY = `
  query RecruitmentApplyForm {
    recruitmentApplyForm {
      id
      title
      defaultRole
      active
      introText
    }
  }
`;

export const UPDATE_APPLY_FORM = `
  mutation UpdateRecruitmentApplyForm($input: UpdateRecruitmentApplyFormInput!) {
    updateRecruitmentApplyForm(input: $input) {
      id
      title
      defaultRole
      active
      introText
    }
  }
`;

export const INTERVIEWS_QUERY = `
  query RecruitmentInterviews {
    recruitmentInterviews {
      id
      applicantId
      name
      role
      interviewer
      type
      scheduledAt
      location
      status
      avatarColor
      notes
      createdAt
    }
  }
`;

export const CREATE_INTERVIEW = `
  mutation CreateRecruitmentInterview($input: CreateRecruitmentInterviewInput!) {
    createRecruitmentInterview(input: $input) {
      id
      applicantId
      name
      role
      interviewer
      type
      scheduledAt
      location
      status
      avatarColor
      notes
    }
  }
`;

export const UPDATE_INTERVIEW = `
  mutation UpdateRecruitmentInterview($id: String!, $input: UpdateRecruitmentInterviewInput!) {
    updateRecruitmentInterview(id: $id, input: $input) {
      id
      interviewer
      type
      scheduledAt
      location
      status
      notes
    }
  }
`;

export const UPDATE_INTERVIEW_STATUS = `
  mutation UpdateRecruitmentInterviewStatus($id: String!, $status: InterviewStatus!) {
    updateRecruitmentInterviewStatus(id: $id, status: $status) {
      id
      status
    }
  }
`;

export const REMOVE_INTERVIEW = `
  mutation RemoveRecruitmentInterview($id: String!) {
    removeRecruitmentInterview(id: $id)
  }
`;

export const INTERVIEW_TYPE_LABEL = {
  video: 'Video Call',
  in_person: 'In-Person',
  phone: 'Phone',
};

export const INTERVIEW_STATUS_LABEL = {
  scheduled: 'Scheduled',
  completed: 'Completed',
  rescheduled: 'Rescheduled',
  cancelled: 'Cancelled',
};

export function formatInterviewDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatInterviewTime(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleTimeString('en-AU', {
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function mapInterview(row) {
  return {
    id: row.id,
    applicantId: row.applicantId || '',
    name: row.name,
    role: row.role,
    interviewer: row.interviewer || 'Unassigned',
    type: row.type || 'video',
    scheduledAt: row.scheduledAt,
    date: formatInterviewDate(row.scheduledAt),
    time: formatInterviewTime(row.scheduledAt),
    location: row.location || 'TBD',
    status: row.status || 'scheduled',
    avatar: row.avatarColor || '#60a5fa',
    notes: row.notes || '',
    createdAt: row.createdAt,
  };
}

export const JOB_OFFERS_QUERY = `
  query RecruitmentJobOffers {
    recruitmentJobOffers {
      id
      applicantId
      name
      role
      salary
      branch
      offerDate
      expiresAt
      status
      avatarColor
      notes
      createdAt
    }
  }
`;

export const CREATE_JOB_OFFER = `
  mutation CreateRecruitmentJobOffer($input: CreateRecruitmentJobOfferInput!) {
    createRecruitmentJobOffer(input: $input) {
      id
      name
      role
      salary
      branch
      offerDate
      expiresAt
      status
      avatarColor
    }
  }
`;

export const UPDATE_JOB_OFFER_STATUS = `
  mutation UpdateRecruitmentJobOfferStatus($id: String!, $status: JobOfferStatus!) {
    updateRecruitmentJobOfferStatus(id: $id, status: $status) {
      id
      status
    }
  }
`;

export const UPDATE_JOB_OFFER = `
  mutation UpdateRecruitmentJobOffer($id: String!, $input: UpdateRecruitmentJobOfferInput!) {
    updateRecruitmentJobOffer(id: $id, input: $input) {
      id
      name
      role
      salary
      branch
      offerDate
      expiresAt
      status
      notes
      avatarColor
    }
  }
`;

export const BACKGROUND_CHECKS_QUERY = `
  query RecruitmentBackgroundChecks {
    recruitmentBackgroundChecks {
      id
      applicantId
      bgcId
      name
      role
      status
      policeCheck
      identityCheck
      referenceCheck
      employmentCheck
      docsUploaded
      avatarColor
      notes
      createdAt
    }
  }
`;

export const CREATE_BACKGROUND_CHECK = `
  mutation CreateRecruitmentBackgroundCheck($input: CreateRecruitmentBackgroundCheckInput!) {
    createRecruitmentBackgroundCheck(input: $input) {
      id
      bgcId
      name
      role
      status
      policeCheck
      identityCheck
      referenceCheck
      employmentCheck
      docsUploaded
      avatarColor
    }
  }
`;

export const UPDATE_BACKGROUND_STATUS = `
  mutation UpdateRecruitmentBackgroundCheckStatus($id: String!, $status: BackgroundCheckStatus!) {
    updateRecruitmentBackgroundCheckStatus(id: $id, status: $status) {
      id
      status
      policeCheck
      identityCheck
      referenceCheck
      employmentCheck
    }
  }
`;

export const UPDATE_BACKGROUND_CHECK = `
  mutation UpdateRecruitmentBackgroundCheck($id: String!, $input: UpdateRecruitmentBackgroundCheckInput!) {
    updateRecruitmentBackgroundCheck(id: $id, input: $input) {
      id
      name
      role
      status
      policeCheck
      identityCheck
      referenceCheck
      employmentCheck
      docsUploaded
      notes
      avatarColor
    }
  }
`;

export const BUMP_BACKGROUND_DOCS = `
  mutation BumpRecruitmentBackgroundDocs($id: String!) {
    bumpRecruitmentBackgroundDocs(id: $id) {
      id
      docsUploaded
      status
    }
  }
`;

export function applicantInitials(name) {
  return String(name || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() || '')
    .join('');
}

export function priorityLabel(priority) {
  if (priority === 'high') return 'High Priority';
  if (priority === 'low') return 'Low Priority';
  return 'Normal';
}

export function stageTitle(stageId) {
  return RECRUITMENT_STAGES.find((s) => s.id === stageId)?.title || stageId;
}

export function formatAppliedDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatShortDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
  });
}

export function mapApplicant(row) {
  return {
    id: row.id,
    appId: row.appId,
    name: row.name,
    role: row.role,
    experience: row.experience || '—',
    date: formatShortDate(row.appliedDate || row.createdAt),
    appliedDate: formatAppliedDate(row.appliedDate || row.createdAt),
    priority: row.priority || 'normal',
    stage: row.stage || 'new',
    avatar: row.avatarColor || '#60a5fa',
    email: row.email || '',
    phone: row.phone || '',
    branch: row.branch || '',
    recruiter: row.recruiter || '',
    notes: row.notes || '',
    resumeFileKey: row.resumeFileKey || '',
    resumeFileName: row.resumeFileName || '',
    resumeFileUrl: row.resumeFileUrl || '',
    createdAt: row.createdAt,
  };
}

export function isCreatedToday(value) {
  if (!value) return false;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return false;
  const now = new Date();
  return (
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate()
  );
}
